// Central catalog of Grindrod terminals the portal supports.
// The Login/Register pickers, the Coming Soon labels, and the ProtectedRoute
// gating all read from here so we can add a terminal in ONE place.

export const TERMINALS = [
    {
        id: "richards_bay",
        name: "Grindrod Richards Bay Terminal",
        short: "Richards Bay",
        active: true,
    },
    {
        id: "maputo",
        name: "Grindrod Maputo Terminal",
        short: "Maputo",
        active: false,
    },
];

export const TERMINAL_LABEL_BY_ID = TERMINALS.reduce((acc, t) => {
    acc[t.id] = t.name;
    return acc;
}, {});

export const TERMINAL_SHORT_BY_ID = TERMINALS.reduce((acc, t) => {
    acc[t.id] = t.short;
    return acc;
}, {});

export function isActiveTerminal(id) {
    const t = TERMINALS.find((x) => x.id === id);
    return !!(t && t.active);
}
